var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3181 13.3638C13.247 13.3638 14 12.6108 14 11.6819C14 10.753 13.247 10 12.3181 10C11.3892 10 10.6362 10.753 10.6362 11.6819C10.6362 12.6108 11.3892 13.3638 12.3181 13.3638Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68188 13.3638C6.61076 13.3638 7.36377 12.6108 7.36377 11.6819C7.36377 10.753 6.61076 10 5.68188 10C4.75301 10 4 10.753 4 11.6819C4 12.6108 4.75301 13.3638 5.68188 13.3638Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6819 13.3638C19.6108 13.3638 20.3638 12.6108 20.3638 11.6819C20.3638 10.753 19.6108 10 18.6819 10C17.753 10 17 10.753 17 11.6819C17 12.6108 17.753 13.3638 18.6819 13.3638Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/setup.bd456644ad26e938b555d017f386952e.svg";
export { ForwardRef as ReactComponent };